<template>
  <DashboardWidgetGauge class="widget-turnover-attivita" :loading="loading" title="Turnover Attività" :min="min" :max="max" :value="value" />
</template>

<script>

export default {
  name: 'dashboard-widget-turnover-attivita',
  components: {
    DashboardWidgetGauge: () => import('../BaseWidgets/DashboardWidgetGauge'),
  },
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 6,
    },
    value: {
      type: Number,
    },
  },
  data () {
    return {
      loading: false,
    };
  },
};

</script>
